/* global navigator */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPlatformBrowser } from '@angular/common';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OfflineService {
  private serviceWorkerRegistration: ServiceWorkerRegistration;

  private offlineSubjects = new Map<string, Subject<any>>();

  constructor(@Inject(PLATFORM_ID) readonly platformId: string) {
    if (isPlatformBrowser(platformId)) {
      if (navigator.serviceWorker) {
        const messageChannel = new MessageChannel();

        navigator.serviceWorker.addEventListener('message', (event) => {
          // event is a MessageEvent object
          if (event.data.customerId && event.data.identifier) {
            const key = `${event.data.customerId}_${event.data.identifier}`;

            if (!this.offlineSubjects.has(key)) {
              this.offlineSubjects.set(key, new Subject<any>());
            }
            const subject = this.offlineSubjects.get(key);
            subject.next(event.data);
          }
        });

        navigator.serviceWorker.ready.then((registration) => {
          this.serviceWorkerRegistration = registration;

          registration.active.postMessage(
            {
              type: 'INIT_PORT',
            },
            [messageChannel.port2],
          );

          // Listen to the response
          messageChannel.port1.onmessage = (event) => {
            // Print the result
            const key = `${event.data.customerId}_${event.data.identifier}`;

            if (!this.offlineSubjects.has(key)) {
              this.offlineSubjects.set(key, new Subject<any>());
            }
            const subject = this.offlineSubjects.get(key);
            subject.next(event.data);
          };
        });
      }
    }
  }

  public dispatchGetOfflineData(customerId: number, identifier: string): boolean {
    if (this.serviceWorkerRegistration?.active) {
      this.serviceWorkerRegistration.active.postMessage({
        type: 'RETRIEVE_OFFLINE_DATA',
        customerId,
        identifier,
      });
      return true;
    }
    return false;
  }

  public dispatchDeleteOfflineData(customerId: number, identifier: string): boolean {
    if (this.serviceWorkerRegistration?.active) {
      this.serviceWorkerRegistration.active.postMessage({
        type: 'DELETE_OFFLINE_DATA',
        customerId,
        identifier,
      });
      return true;
    }
    return false;
  }

  public getOfflineDataObservable$(customerId: number, identifier: string): Observable<any> {
    const key = `${customerId}_${identifier}`;
    if (!this.offlineSubjects.has(key)) {
      this.offlineSubjects.set(key, new Subject<any>());
    }
    const subject = this.offlineSubjects.get(key);
    return subject.asObservable();
  }
}
